import CampaignIssuesAssessment from './campaignIssuesAssessment'

export default CampaignIssuesAssessment
